import { render } from "./MsRadio.vue?vue&type=template&id=8972f226&scoped=true"
import script from "./MsRadio.vue?vue&type=script&lang=js"
export * from "./MsRadio.vue?vue&type=script&lang=js"

import "./MsRadio.vue?vue&type=style&index=0&id=8972f226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8972f226"]])

export default __exports__